import { convertToObject } from '~shared/util';
/**
 * "Enum" of server returned package names
 */
export const EXTERNAL_SCRIPTS: readonly string[] = Object.freeze(['https://js.stripe.com/v3/']);

const PACKAGES_MAPPING_DATA = Object.freeze([
  'BASIC',
  'STANDARD_MONTHLY',
  'STANDARD_ANNUAL',
  'ADVANTAGE_MONTHLY',
  'ADVANTAGE_ANNUAL',
  'PREMIER_MONTHLY',
  'PREMIER_ANNUAL',
  'TEAM_ADVANTAGE_ANNUAL',
  'TEAM_PREMIER_ANNUAL',
  'ENT_PLATINUM',
  'ANALYZE_MONTHLY',
]);

export const PACKAGES_MAPPING_DATA_OPTIONS = convertToObject(...PACKAGES_MAPPING_DATA);

export const PACKAGES: Record<string, string> = {
  Basic: PACKAGES_MAPPING_DATA_OPTIONS.BASIC,
  StandardMonthly: PACKAGES_MAPPING_DATA_OPTIONS.STANDARD_MONTHLY,
  StandardAnnual: PACKAGES_MAPPING_DATA_OPTIONS.STANDARD_ANNUAL,
  AdvantageMonthly: PACKAGES_MAPPING_DATA_OPTIONS.ADVANTAGE_MONTHLY,
  AdvantageAnnual: PACKAGES_MAPPING_DATA_OPTIONS.ADVANTAGE_ANNUAL,
  PremierMonthly: PACKAGES_MAPPING_DATA_OPTIONS.PREMIER_MONTHLY,
  PremierAnnual: PACKAGES_MAPPING_DATA_OPTIONS.PREMIER_ANNUAL,
  TeamAdvantage: PACKAGES_MAPPING_DATA_OPTIONS.TEAM_ADVANTAGE_ANNUAL,
  TeamPremier: PACKAGES_MAPPING_DATA_OPTIONS.TEAM_PREMIER_ANNUAL,
  Enterprise: PACKAGES_MAPPING_DATA_OPTIONS.ENT_PLATINUM,
  Flex: PACKAGES_MAPPING_DATA_OPTIONS.ANALYZE_MONTHLY,
};

type PACKAGE_KEYS = keyof typeof PACKAGES;
type PACKAGE_VALUES = typeof PACKAGES[PACKAGE_KEYS];

export const PACKAGE_IDS: Record<PACKAGE_VALUES, number> = {
  [PACKAGES.Basic]: 1,
  [PACKAGES.StandardMonthly]: 31,
  [PACKAGES.StandardAnnual]: 32,
  [PACKAGES.AdvantageMonthly]: 33,
  [PACKAGES.AdvantageAnnual]: 34,
  [PACKAGES.PremierMonthly]: 35,
  [PACKAGES.PremierAnnual]: 36,
  [PACKAGES.TeamAdvantage]: 134,
  [PACKAGES.TeamPremier]: 136,
  [PACKAGES.Enterprise]: 26,
  [PACKAGES.Flex]: 37,
};

export const MONTHLY_PACKAGES: string[] = [
  PACKAGES.StandardMonthly,
  PACKAGES.AdvantageMonthly,
  PACKAGES.PremierMonthly,
];

export const INDIVIDUAL_PACKAGES: string[] = [
  PACKAGES.PremierAnnual,
  PACKAGES.AdvantageAnnual,
  PACKAGES.StandardMonthly,
];

export const TEAMS_PACKAGES: string[] = [PACKAGES.TeamAdvantage, PACKAGES.TeamPremier, PACKAGES.Enterprise];

export const SUITE_PRICING_PACKAGES: string[] = [
  PACKAGES.AdvantageAnnual,
  PACKAGES.TeamAdvantage,
  PACKAGES.TeamPremier,
];

export const GUAC_COUNTRY_CODES = Object.freeze(['gb', 'us', 'au', 'ca']);

type ComparisonPackages = {
  [x: string]: string;
};

export const COMPARISON_PACKAGES: ComparisonPackages = {
  [PACKAGES.TeamAdvantage]: PACKAGES.AdvantageAnnual,
  [PACKAGES.TeamPremier]: PACKAGES.PremierAnnual,
};

// A list of packages that should display highlighted
export const HIGHLIGHTED_PACKAGES = [PACKAGES.AdvantageAnnual];

// these domains do not get hreflang tags added to their <head>
export const SKIP_HREF_LANG_TAGS = Object.freeze({
  'de.surveymonkey.com': true,
  'ru.surveymonkey.com': true,
});
